// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auditionbar {
  position: relative;
  display: flex;
  justify-content: space-around;
  top: 0px;
  width: 100%;
}

.auditionsq {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 300px;
  color: white;
  font-size: 5rem;
  text-align: center;
  justify-content: center;
}

@media (max-width: 1200px) {
  .auditionbar {
    flex-wrap: wrap;
  }
  .auditionsq {
    margin-bottom: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/audition/styles/audition.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,QAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AACJ;;AACA;EACI;IACI,eAAA;EAEN;EAAE;IACI,mBAAA;EAEN;AACF","sourcesContent":[".auditionbar{\n    position: relative;\n    display: flex;\n    justify-content: space-around;\n    top: 0px;\n    width: 100%;\n}\n\n.auditionsq{\n    display: flex;\n    flex-direction: column;\n    width: 300px;\n    height: 300px;\n    color: #ffff;\n    font-size: 5rem;\n    text-align: center;\n    justify-content: center;\n}\n@media (max-width:1200px) {\n    .auditionbar {\n        flex-wrap: wrap;\n    }\n    .auditionsq {\n        margin-bottom: 2rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
